import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import UserProgressContext from "../../userProgressContext";
import axios from "../../baseURL";
import { validateEmail, validateName } from "../../utils/validateInput";
import httpService from "../../services/httpService";
import { saveUserProgress } from "../../services/saveUserProgress";
import BackgroundSoundToggle from "../BackgroundSound/backGroundSoundToggle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";

const EntryPage = () => {
  const {
    isStartOver,
    setIsStartOver,
    setIsUserProgressFetched,
    setProgress,
    setTotalScore,
    name,
    setName,
    emailId,
    setEmailId,
    setRedeemedScores,
    setFinishedTasks,
  } = useContext(UserProgressContext);
  const [nameInput, setNameInput] = useState(name ? name : "");
  const [emailInput, setEmailInput] = useState(emailId ? emailId : "");

  const [nameInputerror, setNameInputError] = useState("");
  const [emailInputerror, setEmailInputError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  // useEffect(() => {
  //   const fetchClientIp = async () => {
  //     try {
  //       console.log("inside entryPage useEffect 1");
  //       setClientIP(await getClientIP());
  //     } catch (error) {
  //       console.error("Error fetching client IP:", error);
  //     }
  //   };
  //   fetchClientIp();
  // }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Load initial state from backend on component mount
  // useEffect(() => {
  //   console.log("inside entryPage useEffect 2", name, clientIP);
  //   try {
  //     if (name && clientIP) {
  //       console.log("inside entryPage useEffect 2.1");
  //       fetchUserProgressFromBackend();
  //     }
  //   } catch (error) {
  //     console.error("Error fetching client IP:", error);
  //   }
  // }, [name, clientIP]); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchUserProgressFromBackend = async () => {
    try {
      const response = await httpService.get(axios.baseURL, {
        params: { userName: nameInput, emailId: emailInput },
      });
      if (response.data && response.data.length > 0) {
        setIsUserProgressFetched(true);
        const userData = response.data[0];

        // console.log(
        //   "userData @fetchUserProgressFromBackend2",
        //   userData,
        //   userData.progress,
        //   userData.redeemedScores,
        //   progress
        // );
        // const { progress, totalScore, redeemedScores, finishedTasks } = userData;
        // if (progress === null) {
        // console.log(
        //   "userData @fetchUserProgressFromBackend3",
        //   userData.progress,
        //   progress
        // );
        setProgress(userData.progress ? userData.progress : 0);
        sessionStorage.setItem("progress", JSON.stringify(userData.progress));
        // }
        // if (totalScore === 0) {
        setTotalScore(userData.totalScore);
        sessionStorage.setItem(
          "totalScore",
          JSON.stringify(userData.totalScore)
        );
        // }
        setRedeemedScores(new Set(userData.redeemedScores));
        sessionStorage.setItem(
          "redeemedScores",
          JSON.stringify(userData.redeemedScores)
        );
        setFinishedTasks(new Set(userData.finishedTasks));
        sessionStorage.setItem(
          "finishedTasks",
          JSON.stringify(userData.finishedTasks)
        );
        return userData;
      }
    } catch (error) {
      console.error("Error fetching user progress:", error);
    }
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setIsLoading(true);
      const nameValidationError = validateName(nameInput);
      const emailValidationError = validateEmail(emailInput);
      if (!nameValidationError && !emailValidationError) {
        if (emailInput && nameInput) {
          const responseObj = await saveUserProgress({
            name: nameInput,
            emailId: emailInput,
            // redeemedScores: redeemedScores,
            // finishedTasks: finishedTasks,
          });
          if (responseObj && !responseObj.created) {
            const userData = await fetchUserProgressFromBackend();
            setTimeout(() => {
              if (isStartOver) {
                setIsStartOver(false);
                // Player already saw GameResume and chose to start over — go directly to game after difficulty
                navigate("/difficulty", { state: { pendingRoute: "/level/0" } });
              } else {
                // Returning player with existing progress — difficulty already chosen, skip selection
                navigate("/gameResume");
              }
            }, 500);
          } else {
            setProgress(0);
            setIsUserProgressFetched(true);
            navigate("/difficulty", { state: { pendingRoute: "/level/0" } });
          }
        }
        setName(nameInput.toUpperCase());
        setEmailId(emailInput);
      } else {
        setNameInputError(nameValidationError);
        setEmailInputError(emailValidationError);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error updating user progress:", error);
    }
  };
  const handleNameChange = (e) => {
    const value = e.target.value;
    setNameInput(value);
    // setNameInputError(validateName(value));
  };
  const handleEmailIdChange = (e) => {
    const value = e.target.value;
    setEmailInput(value);
    // setEmailInputError(validateEmail(value));
  };

  return (
    <div className="min-h-screen z-10 flex flex-col items-center p-6 md:p-12 bg-cyber-bg/85 text-cyber-text rounded-lg shadow-2xl max-w-4xl mx-auto border border-cyber-dim">
      <h1 className="text-2xl md:text-4xl font-bold mt-4 mb-8 md:mb-16 text-center tracking-widest uppercase text-cyber-accent">
        Welcome to OT Cybersecurity Adventure!
      </h1>
      <h1 className="text-lg md:text-2xl font-bold mb-4 md:mb-8 text-center tracking-wider text-cyber-faint uppercase">
        Enter Your Information
      </h1>
      <form onSubmit={handleSubmit} className="w-full max-w-sm">
        <div className="mb-4">
          <input
            type="text"
            // value={nameInput}
            // onChange={(e) => setName(e.target.value)}
            name="userName"
            onChange={handleNameChange}
            placeholder="Your Name"
            className="uppercase w-full px-3 py-2 bg-cyber-deep text-cyber-text rounded border border-cyber-muted focus:outline-none focus:border-cyber-accent placeholder-cyber-sub"
            autoComplete="off"
            defaultValue={name ? name : ""}
            required
          />
          {nameInputerror && (
            <p className="text-red-500 mt-1 text-sm md:text-base">
              {nameInputerror}
            </p>
          )}
        </div>
        <div className="mb-4">
          <div className=" flex gap-1 items-center">
            <input
              type="text"
              // value={nameInput}
              // onChange={(e) => setName(e.target.value)}
              name="userEmail"
              onChange={handleEmailIdChange}
              placeholder="Your email ID"
              className="w-full px-3 py-2 bg-cyber-deep text-cyber-text rounded border border-cyber-muted focus:outline-none focus:border-cyber-accent placeholder-cyber-sub"
              autoComplete="off"
              defaultValue={emailId ? emailId : ""}
              required
            />
            <div className="group relative">
              <FontAwesomeIcon
                className="text-lg cursor-pointer"
                icon={faCircleInfo}
              />
              <span className="absolute opacity-0 transition-opacity duration-200 ease-in bg-black/90 p-1.5 text-xs text-gray-300 rounded-md w-32 -top-1/3 -left-[500%] mx-auto group-hover:opacity-100">
                Please note that your Email ID is utilized exclusively for
                tracking your game progress. It will not be shared or used for
                any other purposes.
              </span>
            </div>
          </div>
          {emailInputerror && (
            <p className="text-red-500 mt-1 text-sm md:text-base">
              {emailInputerror}
            </p>
          )}
        </div>
        <button
          type="submit"
          disabled={isLoading}
          className="w-full bg-cyber-panel hover:bg-cyber-muted border border-cyber-accent text-cyber-accent font-bold py-2 px-4 rounded tracking-widest uppercase transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isLoading ? "Authenticating..." : "Start Adventure"}
        </button>
      </form>
      <div className="absolute top-2 md:top-4 right-4">
        <BackgroundSoundToggle />
      </div>
    </div>
  );
};

export default EntryPage;
